import RecommendBoxEditing from "./recommendBoxEditing"
import RecommendBoxUi from "./recommendBoxUi"
import Plugin from "@ckeditor/ckeditor5-core/src/plugin"

export default class RecommendBox extends Plugin {
  static get requires() {
    return [RecommendBoxEditing, RecommendBoxUi]
  }
}
